import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import Colors from '../colors';

const TabsStyled = styled(Tabs)({
  paddingBottom: '0.8rem',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

function NavTabs({ value, setValue, tabTitles, style }) {

  const TabStyled = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    color: Colors.darkGray2,
    fontWeight: '500',
    border: `1px solid ${Colors.mediumGray2}`,
    fontFamily: 'Jost',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    padding: '0 8px',
    minHeight: '5vh',
    fontSize: 'min(2.1vh, 18px)',
    '&:hover': {
      background: Colors.lightGreen2,
    },
    '&.Mui-selected': {
      background: `${Colors.green} !important`,
      border: `1px ${Colors.green} solid !important`,
      color: Colors.white,
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {
      backgroundColor: Colors.lightBlue2,
    },
    '&:first-of-type': {
      borderBottomLeftRadius: '2rem',
      borderTopLeftRadius: '2rem',
    },
    '&:last-child': {
      borderBottomRightRadius: '2rem',
      borderTopRightRadius: '2rem',
    },
    ...style,
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <TabsStyled value={value} onChange={handleChange} aria-label="ant example" variant='fullWidth'>
        <TabStyled label={tabTitles[0]} />
        <TabStyled label={tabTitles[1]} />
        <TabStyled label={tabTitles[2]} />
      </TabsStyled>
    </Box>
  );
}

export default NavTabs;